import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Collapse from '@mui/material/Collapse';
import type React from 'react';

type Props = {
  in: boolean;
  onRefreshClick: () => void;
};

export default function StaleTransactionRefreshBanner({ in: show, onRefreshClick }: Props): React.JSX.Element {
  return (
    <Collapse in={show}>
      <Alert
        severity='info'
        action={
          <Button id='refresh-to-sync-button' endIcon={<RefreshRoundedIcon />} size='small' onClick={onRefreshClick}>
            Refresh to sync
          </Button>
        }
        sx={{ borderRadius: 0 }}
      >
        New edits were made to this transaction. Refresh to update.
      </Alert>
    </Collapse>
  );
}
